import {
  GET_ORDER_ITEMS_LOCATIONS,
  GET_ORDER_ITEMS_LOCATIONS_LOADING
} from 'store/actions/app/order_items_locations.actions'

const initialState = {
  loading_order_items_locations: false,
  order_items_locations: {
    pedido_info: null,
    items: []
  }
}

const orderItemsLocationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDER_ITEMS_LOCATIONS_LOADING:
      return {
        ...state,
        loading_order_items_locations: action.payload
      }
    case GET_ORDER_ITEMS_LOCATIONS:
      return {
        ...state,
        order_items_locations: action.payload
      }
    default:
      return state
  }
}

export default orderItemsLocationsReducer
